import React from 'react';
import { Badge } from './Badge';
import { Heading } from './Heading';
interface SectionHeaderProps {
  badge?: string;
  title: string | React.ReactNode;
  description?: string;
  className?: string;
  centered?: boolean;
}
/**
 * Reusable SectionHeader component with Badge, Heading, and Description
 * Provides consistent section header styling across all components
 *
 * @param badge - Optional badge text (e.g., "Dashboard Features")
 * @param title - Main heading text or React node
 * @param description - Optional description text
 * @param centered - Center align content (default: true)
 *
 * @example
 * <SectionHeader
 *   badge="Features"
 *   title="Your Dashboard for Smarter Decisions"
 *   description="Track your entire pipeline in one place"
 * />
 */
export function SectionHeader({
  badge,
  title,
  description,
  className = '',
  centered = true
}: SectionHeaderProps) {
  const alignmentClass = centered ? 'items-center text-center' : 'items-start text-left';
  return <div className={`flex flex-col gap-8 ${alignmentClass} ${className}`} data-id="element-2230">
      {/* Badge */}
      {badge && <div className={centered ? 'flex justify-center' : ''} data-id="element-2231">
          <Badge data-id="element-2232">{badge}</Badge>
        </div>}

      {/* Title and Description */}
      <div className={`flex flex-col gap-6 ${alignmentClass} w-full max-w-4xl`} data-id="element-2233">
        {/* Title */}
        {typeof title === 'string' ? <Heading level="h1" className="text-white" data-id="element-2234">
            {title}
          </Heading> : title}

        {/* Description */}
        {description && <p className="text-xl md:text-2xl text-[#b8bcc8] leading-relaxed max-w-3xl" data-id="element-2235">
            {description}
          </p>}
      </div>
    </div>;
}